import BasicButton from "components/General/BasicButton";
import { useGameContext } from "GameContext";
import { useChatContext } from "ChatContext";

import {
  useState,
  useMemo,
} from "react";

export default function NewChat({
  onBackClick=() => null,
  onCreateRoomDone= () => null,
} : {
  onBackClick?: () => void,
  onCreateRoomDone?: () => void,
}) {
  const {
    playerInfo,
    hostId,
    players,
  } = useGameContext() as any;
  const { createChatRoom } = useChatContext();

  function generateRandCode(seed: number = 0, length = 4) {
    const randomFactor = Math.floor(Math.random() * 36 ** length);
    const combined = seed + randomFactor;
    
    // Convert to base-36
    const base36Hash = combined.toString(36).toUpperCase();
    
    return base36Hash.padStart(length, '0').substring(0, length);
  }

  const [contacts, setContacts] = useState<any[]>([])
  const [participants, setParticipants] = useState<number[]>([])

  function onCreateRoomClick() {
    // const roomCode = generateRandCode(0);
    const userHash = [...participants]
    if (userHash.length < 1) {
      alert("Select at least one participant");
      return
    }

    userHash.sort()

    createChatRoom(userHash.toString(), participants)
    onCreateRoomDone()
  }

  const estatePlayers = useMemo(() => {
    if (!playerInfo) {
      return players
    }
    const result = players.filter((player: any) => player.estate === playerInfo.estate);
    return result
  }, [players, playerInfo])


  return (
    <div className="relative w-full h-full bg-[#a19881] p-2 flex flex-col gap-2 border-2 border-black">
      <button onClick={onBackClick} className="border border-black py-1 px-2 absolute left-2 top-2 bg-[#BCB7A8]">{"back"}</button>
      <div className="w-full text-center text-lg mb-4">Contacts</div>
      <div className="flex flex-col gap-1">
        {estatePlayers.map((ply: any, i: number) => (
          <button key={ply.id ?? i} className={`flex flex-row justify-between items-center bg-[#BCB7A8] p-2 rounded-full border border-black`}
            onClick={() => {
              if (participants.includes(ply.id)) {
                setParticipants(participants.filter(p => p !== ply.id))
              } else {
                setParticipants([...participants, ply.id])
              }
            }}
          >
            <div className="flex flex-row gap-2 items-center">
              <div className="">{ply.playerName}</div>
              <div className="border border-black rounded-full px-2 py-1">{ply.estate}</div>
              <div className="border border-black rounded-full px-2 py-1">{ply.role}</div>
            </div>
            <div className={`border border-black rounded-full px-2 py-1 ${ participants.includes(ply.id) ? "bg-[#a19881]" : "bg-[#BCB7A8]"}`}>{participants.includes(ply.id) ? "x" : "+"}</div>
          </button>
        ))}
      </div>
      <div className="flex h-full"/>
      {participants.length > 0 && (
        <div className="text-center">Selected ({participants.length})</div>
      )}
      <BasicButton text={"Create Chat"} onClick={onCreateRoomClick} />
    </div>
  )
}
